// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"3f58aa55","313":"28962962","510":"5eebdca2","652":"0b337d55","829":"0635e851","873":"3f7fb6fe"}[chunkId] + ".chunk.js";
};